import { render, staticRenderFns } from "./RequireChangePassword.vue?vue&type=template&id=35332d66&"
import script from "./RequireChangePassword.vue?vue&type=script&lang=js&"
export * from "./RequireChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35332d66')) {
      api.createRecord('35332d66', component.options)
    } else {
      api.reload('35332d66', component.options)
    }
    module.hot.accept("./RequireChangePassword.vue?vue&type=template&id=35332d66&", function () {
      api.rerender('35332d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RequireChangePassword.vue"
export default component.exports